export type AiResultsColumns = 1 | 2 | 3 | 4;

export const AI_RESULTS_COLUMNS_STORAGE = {
  textToImage: "wembii-ai-results-columns-text-to-image",
  aiGeneration: "wembii-ai-results-columns-ai-generation",
} as const;

export function loadAiResultsColumns(
  key: string,
  defaultCols: AiResultsColumns = 3
): AiResultsColumns {
  try {
    const raw = localStorage.getItem(key);
    const n = parseInt(raw || "", 10);
    if (n >= 1 && n <= 4) return n as AiResultsColumns;
  } catch {
    // ignore
  }
  return defaultCols;
}

export function saveAiResultsColumns(
  key: string,
  cols: AiResultsColumns
): void {
  try {
    localStorage.setItem(key, String(cols));
  } catch {
    // quota / private mode
  }
}
